export const sortByCreatedAtIfExists = (arr) => {
  if (!Array.isArray(arr)) return arr;

  const hasCreatedAt = arr.every(
    (item) => item && Object.prototype.hasOwnProperty.call(item, "createdAt")
  );

  if (!hasCreatedAt) {
    return arr;
  }

  return [...arr].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
};
